'use client'

import { useEffect } from 'react'
import { captureClientException } from '@/lib/posthog'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    captureClientException(error, {
      error_boundary: 'global',
      digest: error.digest,
    })
  }, [error])

  return (
    <html lang="en">
      <body>
        <main className="min-h-screen grid place-items-center bg-black px-6 text-white">
          <div className="max-w-xl text-center">
            <h1 className="text-5xl font-medium">Something went wrong</h1>
            <p className="mt-5 text-white/70">Please try again. If the problem continues, our team has the error details.</p>
            <button className="mt-8 min-h-11 rounded-full bg-red-700 px-7" onClick={reset}>Try again</button>
          </div>
        </main>
      </body>
    </html>
  )
}
